import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './App'
import reportWebVitals from './reportWebVitals'
import './assets/scss/index.scss'
import { Provider } from 'react-redux'
import { store } from './store'

const Root = (
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
)

ReactDOM.render(Root, document.getElementById('root'))

reportWebVitals()
